/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: refactor
 * @LastEditTime: 2026-03-25
 */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'

import { useAppSelector, useAppDispatch } from '../../../../../app/hooks'
import { setEditorCascadeItemsList } from '../../../../../actions/watermark'
import ItemTree from './ItemTree'
import BatchImportCascadeItems from '../BatchImportCascadeItems'
import { PlusCircleFilled } from '@ant-design/icons'

interface CascadeProps {
  index: number
  clickEvent: (clickItem: string) => void
}

interface UploadLocation {
  lat: string
  lng: string
}

export interface ItemNode {
  // uploadLocation: UploadLocation[]
  content: string
  key?: string
  childs?: ItemNode[]
}

const Cascade: React.FC<CascadeProps> = (props) => {
  const { index, clickEvent } = props
  const [importVisible, setImportVisible] = useState(false)
  const itemsWrapperRef = useRef<HTMLDivElement>(null)
  const dispatch = useAppDispatch()
  const watermark = useAppSelector((state) => state.editor.watermark)
  const allCascadeItems = useAppSelector((state) => state.editor.cascadeItems)

  const cascadeItemIndex = useMemo(() => {
    return allCascadeItems.findIndex(
      (item) => item.itemId === watermark?.items?.[index]?.id
    )
  }, [watermark, allCascadeItems, index])

  const cascadeItemRecordsNum = useMemo(() => {
    const records = allCascadeItems[cascadeItemIndex]?.records
    return records ? records.length : 0
  }, [watermark, allCascadeItems, cascadeItemIndex])

  const prevRecordsNum = useRef(cascadeItemRecordsNum)

  const onAddItem = useCallback(() => {
    const records = allCascadeItems[cascadeItemIndex]?.records || []
    if (cascadeItemIndex === -1) {
      dispatch(
        setEditorCascadeItemsList([
          ...allCascadeItems,
          {
            itemId: watermark?.items?.[index]?.id,
            records: [
              {
                content: '',
                childs: []
              }
            ]
          }
        ])
      )
    } else {
      const newCascadeItems = allCascadeItems.map((item, idx) =>
        idx === cascadeItemIndex
          ? {
              ...item,
              records: [
                ...records,
                {
                  content: '',
                  childs: []
                }
              ]
            }
          : item
      )
      dispatch(setEditorCascadeItemsList(newCascadeItems))
    }
    clickEvent('addOption')
  }, [watermark, allCascadeItems, cascadeItemIndex, index])

  const onBatchAddClick = () => {
    setImportVisible(true)
    clickEvent('batchAddOption')
  }

  useEffect(() => {
    // //新增条目后，滚动到最后一条
    if (cascadeItemRecordsNum > prevRecordsNum.current) {
      if (itemsWrapperRef.current && itemsWrapperRef.current.children.length) {
        const ul = itemsWrapperRef.current.children[0] as HTMLUListElement
        if (ul.lastChild) {
          ;(ul.lastChild as HTMLElement).scrollIntoView({
            behavior: 'smooth'
          })
        }
      }
    }
    prevRecordsNum.current = cascadeItemRecordsNum
  }, [cascadeItemRecordsNum])

  return (
    <div className="preset-wrapper">
      <div className="preset-title-wrapper ant-form-item-label">
        <label>选项列表：</label>
        <div>
          <button style={{ marginRight: '9px' }} onClick={onAddItem}>
            <PlusCircleFilled />
            添加选项
          </button>
          <button onClick={onBatchAddClick}>
            <PlusCircleFilled />
            批量添加
          </button>
        </div>
      </div>
      <div className="cascade-preset-items-wrapper" ref={itemsWrapperRef}>
        <ItemTree
          itemID={watermark?.items?.[index]?.id}
          clickEvent={clickEvent}
        />
      </div>
      {importVisible && (
        <BatchImportCascadeItems
          index={index}
          itemID={watermark?.items?.[index]?.id}
          onClose={() => setImportVisible(false)}
        />
      )}
    </div>
  )
}

export default Cascade
